import { PersonIcon } from './Profile';

export type Panel = 'chats' | 'ask' | 'media' | 'profile';

/**
 * The narrow column of icons on the far left, as WhatsApp has.
 *
 * It exists so the account stops being a modal. Storage, devices, sign-in and
 * deleting the archive were behind a sheet that covered the conversation you
 * were reading; here they are a panel like any other, and the way back to the
 * conversations is one icon that is always in the same place.
 */
export function Rail({ panel, onPanel, name, avatarUrl }: {
  panel: Panel;
  onPanel: (p: Panel) => void;
  name: string | null;
  avatarUrl: string | null;
}) {
  // O rótulo é desenhado só na barra de baixo, no telefone: lá a trilha é a
  // navegação inteira e um ícone sozinho não diz o que é, que é justamente o
  // que o WhatsApp resolve escrevendo "Chats", "Updates", "You" embaixo.
  const tab = (id: Panel, label: string, icon: React.ReactNode) => (
    <button className={`rail-btn${panel === id ? ' on' : ''}`} title={label}
            aria-label={label} aria-current={panel === id}
            onClick={() => onPanel(id)}>
      {icon}
      <span className="tab">{label}</span>
    </button>
  );

  return (
    <nav className="rail" aria-label="Sections">
      {tab('chats', 'Chats', (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M3.5 6.5h17v10a2 2 0 0 1-2 2H8l-4.5 3.5z" />
          <path d="M7 10.5h10M7 14h6" />
        </svg>
      ))}

      {/* Entre as conversas e o resto: é sobre elas que se pergunta. */}
      {tab('ask', 'Ask', (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M12 3.2l1.7 4.1 4.1 1.7-4.1 1.7L12 14.8l-1.7-4.1L6.2 9l4.1-1.7z" />
          <path d="M18.2 15.4l.8 1.9 1.9.8-1.9.8-.8 1.9-.8-1.9-1.9-.8 1.9-.8z" />
        </svg>
      ))}

      <div className="rail-gap" />

      {tab('media', 'Media', (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <rect x="3.5" y="4.5" width="17" height="15" rx="3" />
          <circle cx="9" cy="10" r="1.5" />
          <path d="M4 16.5l4.5-4.5 4 4 2.5-2.5 5 5" />
        </svg>
      ))}

      {/* The account, where WhatsApp keeps it: last, and a face rather than a
          glyph, because it is the one control that is about you. */}
      <button className={`rail-me${panel === 'profile' ? ' on' : ''}`}
              title="Your account" aria-label="Your account"
              aria-current={panel === 'profile'}
              onClick={() => onPanel('profile')}>
        <span className="face">
          {avatarUrl
            ? <img src={avatarUrl} alt="" referrerPolicy="no-referrer" />
            : name ? <span>{name.slice(0, 1).toUpperCase()}</span> : <PersonIcon />}
        </span>
        <span className="tab">You</span>
      </button>
    </nav>
  );
}
